var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-badge',{staticClass:"text-light font-size-h2 py-4 px-8",attrs:{"variant":_vm.variant()}},[_vm._v(_vm._s(_vm.env))])
}
var staticRenderFns = []

export { render, staticRenderFns }